import { useEffect, useRef, useState, lazy, Suspense } from 'react';

const LazySection = ({ importFn, fallbackHeight = '400px', id }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const Component = useRef(null);

  if (!Component.current) {
    Component.current = lazy(importFn);
  }

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const Comp = Component.current;

  return (
    <div ref={ref} id={id}>
      {visible ? (
        <Suspense fallback={<div style={{ minHeight: fallbackHeight }} />}>
          <Comp />
        </Suspense>
      ) : (
        <div style={{ minHeight: fallbackHeight }} />
      )}
    </div>
  );
};

export default LazySection;
